export default __webpack_public_path__ + "static/media/socketio-whiteboard.5721ae8f.svg";